function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from "react";
import { TopicPageSection_ItemOrDirectChildUpdatedDocument } from "sprout-graphql";
import { Box } from "sprout-ui-primitives";
import { getItemUrl } from "sprout-lib";
import { useNavigationList } from "@sprout/list-navigation";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import { useMergeRefs } from "sprout-hooks";
import FeatureFlaggedSubscription from "@sprout/client-lib/dist/FeatureFlaggedSubscription";
import styled from "styled-components";
import { focusStyles } from "@sprout/client-components/dist/Card";
import useTopicPageSectionMainToggle from "../graphql/mutations/useTopicPageSectionMainToggle";
import TopicPageViewsTopicEditors from "../TopicPage_Views_Topic/TopicPageViewsTopicEditors";
import TopicPageViewsTopicListPosts from "../TopicPage_Views_Topic/TopicPage_Views_Topic_List/TopicPageViewsTopicListPosts";
import TopicPageSectionSections from "./TopicPage_Section_Sections";
import TopicPageSectionSection from "./TopicPageSectionSection";
import TopicPageSectionSpace from "./TopicPageSectionSpace";
import TopicPageSectionPostsSeeMore from "./TopicPageSectionPostsSeeMore";
const TopicPageSectionWrapper = styled(Box)`
  ${focusStyles};
`;
const SUPPORTED_COMMANDS = [
    "OPEN"
];
const TopicPageSection = (props)=>{
    const { topic , expandable , dragProvided , navigationListItemProvided , isDragging , isGroupedOver , isSortEnabled , __hideLater ,  } = props;
    const { userPreferences , id , nodeId , rootTopic  } = topic;
    const { owner  } = rootTopic || {};
    const sectionURL = getItemUrl(topic, owner);
    const mainIsOpen = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.mainIsOpen;
    const isExpanded = expandable ? typeof mainIsOpen === "boolean" ? mainIsOpen : true : false;
    const posts = topic.posts.nodes;
    const postsToRender = useMemo(()=>{
        return posts.filter(({ isExplicitlyArchived , isExplicitlyDeleted  })=>!isExplicitlyArchived && !isExplicitlyDeleted);
    }, [
        posts
    ]);
    const totalPostsCount = topic.posts.totalCount - (posts.length - postsToRender.length);
    const sections = topic.sections.nodes;
    const excessSectionsCount = (topic.directSubtopicCount || 0) - sections.length;
    const showSnackbar = useSnackbar();
    const mainToggle = useTopicPageSectionMainToggle();
    const handleExpand = useCallback(()=>{
        mainToggle({
            itemId: id,
            itemNodeId: nodeId,
            userPreferencesNodeId: userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.nodeId,
            mainIsOpen: !isExpanded
        }).catch(()=>{
            showSnackbar.error();
        });
    }, [
        id,
        isExpanded,
        mainToggle,
        nodeId,
        showSnackbar,
        userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.nodeId, 
    ]);
    const { Provider , navProps  } = useNavigationList(`TopicPageSection|${id}`, useMemo(()=>({
            multiselect: true,
            actions: SUPPORTED_COMMANDS
        }), []));
    const mergedRefs = useMergeRefs(// eslint-disable-next-line @typescript-eslint/unbound-method
    dragProvided === null || dragProvided === void 0 ? void 0 : dragProvided.innerRef, navProps.ref);
    const hasMorePosts = totalPostsCount > postsToRender.length;
    if (!owner) return null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FeatureFlaggedSubscription, {
                subscription: TopicPageSection_ItemOrDirectChildUpdatedDocument,
                variables: {
                    sectionId: id
                }
            }),
            /*#__PURE__*/ _jsxs(TopicPageSectionWrapper, _objectSpread({
                mb: isExpanded ? 7 : undefined,
                ref: mergedRefs
            }, dragProvided && _objectSpread({}, dragProvided.draggableProps, dragProvided.dragHandleProps), {
                children: [
                    /*#__PURE__*/ _jsx(TopicPageSectionSection, {
                        isGroupedOver: isGroupedOver,
                        expandable: expandable,
                        section: topic,
                        navigationListItemProvided: navigationListItemProvided,
                        isExpanded: isExpanded,
                        onExpand: handleExpand,
                        isDragging: !!isDragging
                    }),
                    /*#__PURE__*/ _jsx(Provider, {
                        children: isExpanded && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(TopicPageViewsTopicListPosts, {
                                    posts: postsToRender,
                                    topicId: id,
                                    topicNodeId: nodeId,
                                    context: "page_section",
                                    hasMorePosts: hasMorePosts,
                                    /**
                 * `prepend` is a MUST if you want to use `setActiveItemId` correctly.
                 *
                 * `setActiveItemId` is used by `PostPageTodoNewEditor` to focus the newly
                 * created `TODO`.
                 *
                 * This is due to how the `ListNavigation` context works, `setActiveItemId`
                 * must be called under the `Provider` of the `activeItemId` it wants to set.
                 */ prepend: /*#__PURE__*/ _jsx(TopicPageViewsTopicEditors, {
                                        topicId: id,
                                        topicNodeId: nodeId,
                                        afterItemId: null,
                                        context: "page_section"
                                    }),
                                    isSortEnabled: posts.length === 0 && sections.length === 0 ? false : isSortEnabled,
                                    __hideLater: __hideLater
                                }),
                                hasMorePosts && /*#__PURE__*/ _jsx(TopicPageSectionPostsSeeMore, {
                                    sectionId: id,
                                    sectionURL: sectionURL,
                                    totalPostsCount: totalPostsCount
                                }),
                                postsToRender.length === 0 && /*#__PURE__*/ _jsx(TopicPageSectionSpace, {
                                    sectionId: id,
                                    sectionNodeId: nodeId,
                                    sectionURL: sectionURL,
                                    isEmpty: sections.length === 0
                                }),
                                sections.length > 0 && /*#__PURE__*/ _jsx(TopicPageSectionSections, {
                                    parentTopic: topic,
                                    sections: sections,
                                    owner: owner,
                                    excessSectionsCount: excessSectionsCount
                                })
                            ]
                        })
                    })
                ]
            }))
        ]
    });
};
export default /*#__PURE__*/ memo(TopicPageSection);
